import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/Store";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import "./fashion.css";
import { registerServiceWorker } from "./utils/installApp";

// Entry point.
const root = createRoot(document.getElementById("root"));

registerServiceWorker(); // the store can be installed as an app

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);
